
import { defineComponent, PropType } from 'vue'
import { RunReportGrade } from '~/types/types'

export default defineComponent({
  name: 'ReportCardDimensionRow',
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    issuesCount: {
      type: Number,
      required: true
    },
    grade: {
      type: String as PropType<RunReportGrade>,
      required: true
    }
  }
})
